// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mini-world .mini-world-container {
  position: relative;
  transition: 1s;
  text-align: left;
}
mini-world h1.world-header {
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  padding: 10px;
  font-size: 25px;
  box-sizing: content-box;
  font-weight: bold;
  z-index: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  color: white;
  text-shadow: 0 2px 5px rgba(0, 0, 0, 0.8), 0 -2px 5px rgba(0, 0, 0, 0.8);
  transition: 0.3s;
  pointer-events: none;
}
mini-world h1.world-header.world-header-dark {
  color: #333;
  text-shadow: none;
  transition: 0.3s;
}
mini-world .mini-world-content {
  padding-bottom: 0;
}
mini-world .mini-world-content .mini-world-details {
  position: relative;
  background: #eee;
  max-height: 700px;
  transition: 1s;
}
mini-world .mini-world-content .mini-world-details h1.world-header {
  position: relative;
  opacity: 0;
  color: #333;
  text-shadow: none;
}
mini-world .mini-world-content .mini-world-details .slides-container {
  padding: 10px;
}
mini-world .mini-world-content .mini-world-details .slides-container .slide {
  position: relative;
}
mini-world .swiper-container {
  overflow: visible;
}
mini-world .slides-postion {
  text-align: center;
}
mini-world .slides-postion .position-dot {
  display: inline-block;
  border-radius: 100%;
  width: 12px;
  height: 12px;
  margin: 5px;
  background: #333;
  box-shadow: 0 0 5px rgba(255, 255, 255, 0.3);
  transition: 0.5s;
}
mini-world .slides-postion .position-dot.selected {
  background: goldenrod;
  transform: scale(1.2);
  box-shadow: 0 0 5px rgba(255, 255, 255, 0.3);
}
mini-world .mini-world-content.hide-content {
  padding-bottom: 56%;
}
mini-world .mini-world-content.hide-content .mini-world-details {
  max-height: 0;
  overflow: hidden;
  background: transparent;
  transition: 0.5s;
  background: #333;
}
mini-world .small-slide {
  margin-right: 10px;
  width: 80% !important;
  display: block !important;
}
mini-world .world-container {
  padding-top: 2px;
  padding-bottom: 0px;
}
mini-world .world-image {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}
mini-world h1.hidden-title {
  position: relative;
  display: block;
  opacity: 0;
  margin: 0px;
}
mini-world p {
  line-height: 100%;
}
mini-world p.world-text {
  padding-top: 4px;
  padding-bottom: 20px;
  margin-top: 0px;
}
mini-world p.collection-text {
  display: inline;
}
mini-world .show-details {
  opacity: 1;
  transition: opacity 500ms ease-out;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/mini-world/mini-world.component.scss"],"names":[],"mappings":"AAEI;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;AADR;AAII;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,wEAAA;EACA,gBAAA;EACA,oBAAA;AAFR;AAKI;EACI,WAAA;EACA,iBAAA;EACA,gBAAA;AAHR;AAMI;EACI,iBAAA;AAJR;AAMQ;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAJZ;AAMY;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;AAJhB;AAOY;EACI,aAAA;AALhB;AAOgB;EACI,kBAAA;AALpB;AAWI;EACI,iBAAA;AATR;AAYI;EACI,kBAAA;AAVR;AAWQ;EACI,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,4CAAA;EACA,gBAAA;AATZ;AAYQ;EACI,qBAAA;EACA,qBAAA;EACA,4CAAA;AAVZ;AAcI;EACI,mBAAA;AAZR;AAcQ;EACI,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AAZZ;AAiBI;EACI,kBAAA;EACA,qBAAA;EACA,yBAAA;AAfR;AAqBI;EACI,gBAAA;EACA,mBAAA;AAnBR;AAsBI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AApBR;AAwBI;EACI,kBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;AAtBR;AAyBI;EACI,iBAAA;AAvBR;AA0BI;EACI,gBAAA;EACA,oBAAA;EACA,eAAA;AAxBR;AA2BI;EACI,eAAA;AAzBR;AA4BI;EACI,UAAA;EACA,kCAAA;AA1BR","sourcesContent":["mini-world {\n\n    .mini-world-container {\n        position: relative;\n        transition: 1s;\n        text-align: left;\n    }\n\n    h1.world-header {\n        position: absolute;\n        top: 0;\n        left: 0;\n        margin: 0;\n        padding: 10px;\n        font-size: 25px;\n        box-sizing: content-box;\n        font-weight: bold;\n        z-index: 1;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        width: 100%;\n        color: white;\n        text-shadow: 0 2px 5px rgba(0,0,0,.8), 0 -2px 5px rgba(0,0,0,.8);\n        transition: .3s;\n        pointer-events: none;\n    }\n\n    h1.world-header.world-header-dark {\n        color: #333;\n        text-shadow: none;\n        transition: .3s;\n    }\n\n    .mini-world-content {\n        padding-bottom: 0;\n        \n        .mini-world-details {\n            position: relative;\n            background: #eee;\n            max-height: 700px;\n            transition: 1s;\n\n            h1.world-header {\n                position: relative; \n                opacity: 0;\n                color: #333;\n                text-shadow: none;\n            }\n\n            .slides-container {\n                padding: 10px;\n\n                .slide {\n                    position: relative;\n                }\n            }\n        }\n    }\n\n    .swiper-container {\n        overflow: visible;\n    }\n\n    .slides-postion {\n        text-align: center;\n        .position-dot {\n            display: inline-block;\n            border-radius: 100%;\n            width: 12px;\n            height: 12px;\n            margin: 5px;\n            background: #333;\n            box-shadow: 0 0 5px rgba(255,255,255,.3);\n            transition: .5s;\n        }\n\n        .position-dot.selected {\n            background: goldenrod;\n            transform: scale(1.2);\n            box-shadow: 0 0 5px rgba(255,255,255,.3);\n        }\n    }\n\n    .mini-world-content.hide-content {\n        padding-bottom: 56%;   \n\n        .mini-world-details {\n            max-height: 0;\n            overflow: hidden;\n            background: transparent;\n            transition: .5s;\n            background: #333;\n        }\n    }\n\n\n    .small-slide {\n        margin-right: 10px;\n        width: 80% !important;\n        display: block !important;\n    }\n\n    $open-transition: height 250ms ease-in;\n    $close-transition: height 150ms ease-in;\n\n    .world-container {\n        padding-top: 2px;\n        padding-bottom: 0px;\n    }\n\n    .world-image {\n        position: absolute;\n        top: 0px;\n        left: 0px;\n        width: 100%;\n        height: 100%;\n    }\n\n\n    h1.hidden-title  {\n        position: relative;\n        display:block;\n        opacity: 0;\n        margin:0px;\n    }\n\n    p {\n        line-height: 100%;\n    }\n\n    p.world-text {\n        padding-top: 4px;\n        padding-bottom: 20px;\n        margin-top: 0px;\n    }\n\n    p.collection-text {\n        display: inline;\n    }\n\n    .show-details {\n        opacity: 1;\n        transition: opacity 500ms ease-out;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
